"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var BasePdfClient_1 = require("./BasePdfClient");
Object.defineProperty(exports, "BasePdfClient", { enumerable: true, get: function () { return BasePdfClient_1.default; } });
//# sourceMappingURL=index.js.map